/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: t5CKmWfTpe_O

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { Dialog } from "@plasmicpkgs/radix-ui";
import { RawNull } from "@myevaluations/myevals-plasmic-utils/dist/code-components/RawNull/RawNull"; // plasmic-import: P90l9-wwCsyV/codeComponent
import { DialogContent } from "@plasmicpkgs/radix-ui";
import { TimeoutProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/TimeoutProvider/TimeoutProvider"; // plasmic-import: zOckBc_CLSSy/codeComponent
import { StateProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/StateProvider/StateProvider"; // plasmic-import: OaGu0RHjgthJ/codeComponent
import { FormProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/form/FormProvider"; // plasmic-import: R4jbURjT8nMH/codeComponent
import { DialogTitle } from "@plasmicpkgs/radix-ui";
import { DialogClose } from "@plasmicpkgs/radix-ui";
import ModalCloseButton from "../../ModalCloseButton"; // plasmic-import: mUrFb8Eka3V0/component
import ButtonBar from "../../ButtonBar"; // plasmic-import: E74QHYWzCoX_/component
import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import SpinnerIcon from "../../SpinnerIcon"; // plasmic-import: 0R7aXYvaG7Fy/component
import { FormControlProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/form/FormControlProvider"; // plasmic-import: v9MLUrEpQF_1/codeComponent
import TextInput from "../../TextInput"; // plasmic-import: kx7Qgd3B-3Xa/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicMultiFactorAuthModal.module.css"; // plasmic-import: t5CKmWfTpe_O/css

import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon
import SearchSvgIcon from "./icons/PlasmicIcon__SearchSvg"; // plasmic-import: 4h8B6qj-XIZa/icon

import { zod as __fn_zod } from "@myevaluations/myevals-plasmic-utils/dist/custom-functions/zod"; // plasmic-import: zod/customFunction

createPlasmicElementProxy;

export type PlasmicMultiFactorAuthModal__VariantMembers = {};
export type PlasmicMultiFactorAuthModal__VariantsArgs = {};
type VariantPropType = keyof PlasmicMultiFactorAuthModal__VariantsArgs;
export const PlasmicMultiFactorAuthModal__VariantProps =
  new Array<VariantPropType>();

export type PlasmicMultiFactorAuthModal__ArgsType = {
  open?: boolean;
  onOpenChange?: (val: boolean) => void;
  action?: string;
  onVerify?: (code: string, deliveryMethod: string) => void;
  factors?: any;
  onFactorsChange?: (val: string) => void;
  isChallengeSubmitting?: boolean;
  onIsChallengeSubmittingChange?: (val: string) => void;
  methodSelected?: boolean;
  onMethodSelectedChange?: (val: string) => void;
  cooldown?: any;
  onCooldownChange?: (val: string) => void;
};
type ArgPropType = keyof PlasmicMultiFactorAuthModal__ArgsType;
export const PlasmicMultiFactorAuthModal__ArgProps = new Array<ArgPropType>(
  "open",
  "onOpenChange",
  "action",
  "onVerify",
  "factors",
  "onFactorsChange",
  "isChallengeSubmitting",
  "onIsChallengeSubmittingChange",
  "methodSelected",
  "onMethodSelectedChange",
  "cooldown",
  "onCooldownChange"
);

export type PlasmicMultiFactorAuthModal__OverridesType = {
  root?: Flex__<"div">;
  dialogCore?: Flex__<typeof Dialog>;
  rawNull?: Flex__<typeof RawNull>;
  dialogContent?: Flex__<typeof DialogContent>;
  cooldownProvider?: Flex__<typeof TimeoutProvider>;
  deliveryMethod?: Flex__<typeof StateProvider>;
  modal?: Flex__<"div">;
  formProvider?: Flex__<typeof FormProvider>;
  top?: Flex__<"div">;
  header?: Flex__<"div">;
  titleWrapper?: Flex__<"div">;
  dialogTitle?: Flex__<typeof DialogTitle>;
  h4?: Flex__<"h4">;
  dialogClose?: Flex__<typeof DialogClose>;
  modalCloseButton?: Flex__<typeof ModalCloseButton>;
  methodSelect?: Flex__<"div">;
  body2?: Flex__<"div">;
  heading2?: Flex__<"div">;
  initialDeliveryMethodWrapper?: Flex__<"div">;
  buttonBar2?: Flex__<typeof ButtonBar>;
  footer2?: Flex__<"div">;
  buttons2?: Flex__<"div">;
  selectedMethod?: Flex__<"div">;
  authCodeProvider?: Flex__<typeof FormControlProvider>;
  passwordProvider?: Flex__<typeof FormControlProvider>;
  body?: Flex__<"div">;
  heading?: Flex__<"div">;
  deliveryMethodWrapper?: Flex__<"div">;
  buttonBar?: Flex__<typeof ButtonBar>;
  inputWrapper?: Flex__<"div">;
  codeInputWrapper?: Flex__<"div">;
  authCodeInput?: Flex__<typeof TextInput>;
  authCodeErrorContainer?: Flex__<"div">;
  passwordInputWrapper?: Flex__<"div">;
  passwordInput?: Flex__<typeof TextInput>;
  passwordErrorContainer?: Flex__<"div">;
  footer?: Flex__<"div">;
  buttons?: Flex__<"div">;
  bottom?: Flex__<"div">;
};

export interface DefaultMultiFactorAuthModalProps {
  open?: boolean;
  onOpenChange?: (val: boolean) => void;
  action?: string;
  onVerify?: (code: string, deliveryMethod: string) => void;
  factors?: any;
  onFactorsChange?: (val: string) => void;
  isChallengeSubmitting?: boolean;
  onIsChallengeSubmittingChange?: (val: string) => void;
  methodSelected?: boolean;
  onMethodSelectedChange?: (val: string) => void;
  cooldown?: any;
  onCooldownChange?: (val: string) => void;
  className?: string;
}

const $$ = {
  zod: __fn_zod
};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicMultiFactorAuthModal__RenderFunc(props: {
  variants: PlasmicMultiFactorAuthModal__VariantsArgs;
  args: PlasmicMultiFactorAuthModal__ArgsType;
  overrides: PlasmicMultiFactorAuthModal__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "dialogCore.open",
        type: "writable",
        variableType: "boolean",

        valueProp: "open",
        onChangeProp: "onOpenChange"
      },
      {
        path: "authCodeInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          (() => {
            try {
              return $ctx.authCodeProvider.field.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "factors",
        type: "writable",
        variableType: "array",

        valueProp: "factors",
        onChangeProp: "onFactorsChange"
      },
      {
        path: "deliveryMethod.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "isChallengeSubmitting",
        type: "writable",
        variableType: "boolean",

        valueProp: "isChallengeSubmitting",
        onChangeProp: "onIsChallengeSubmittingChange"
      },
      {
        path: "buttonBar.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          (() => {
            try {
              return (() => {
                return $state.deliveryMethod.value;
              })();
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "passwordInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          (() => {
            try {
              return $ctx.passwordProvider.field.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "buttonBar2.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          (() => {
            try {
              return $state.deliveryMethod.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "methodSelected",
        type: "writable",
        variableType: "boolean",

        valueProp: "methodSelected",
        onChangeProp: "onMethodSelectedChange"
      },
      {
        path: "cooldown",
        type: "writable",
        variableType: "object",

        valueProp: "cooldown",
        onChangeProp: "onCooldownChange"
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root
      )}
    >
      <Dialog
        data-plasmic-name={"dialogCore"}
        data-plasmic-override={overrides.dialogCore}
        className={classNames("__wab_instance", sty.dialogCore)}
        defaultOpen={false}
        onOpenChange={async (...eventArgs: any) => {
          generateStateOnChangeProp($state, ["dialogCore", "open"]).apply(
            null,
            eventArgs
          );

          (async open => {
            const $steps = {};

            $steps["updateMethodSelected"] = !open
              ? (() => {
                  const actionArgs = {
                    variable: {
                      objRoot: $state,
                      variablePath: ["methodSelected"]
                    },
                    operation: 0,
                    value: false
                  };
                  return (({ variable, value, startIndex, deleteCount }) => {
                    if (!variable) {
                      return;
                    }
                    const { objRoot, variablePath } = variable;

                    $stateSet(objRoot, variablePath, value);
                    return value;
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["updateMethodSelected"] != null &&
              typeof $steps["updateMethodSelected"] === "object" &&
              typeof $steps["updateMethodSelected"].then === "function"
            ) {
              $steps["updateMethodSelected"] =
                await $steps["updateMethodSelected"];
            }
          }).apply(null, eventArgs);
        }}
        open={generateStateValueProp($state, ["dialogCore", "open"])}
        overlayClassName={classNames({ [sty["pcls_5JqH63p5shf5"]]: true })}
        themeResetClass={classNames(
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames
        )}
        triggerSlot={
          <RawNull
            data-plasmic-name={"rawNull"}
            data-plasmic-override={overrides.rawNull}
          />
        }
      >
        <DialogContent
          data-plasmic-name={"dialogContent"}
          data-plasmic-override={overrides.dialogContent}
          className={classNames("__wab_instance", sty.dialogContent)}
          enterAnimations={["zoom-enter"]}
          enterDuration={0.3}
          exitAnimations={["zoom-exit"]}
          exitDuration={0.25}
          themeResetClass={classNames(
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            styleTokensClassNames
          )}
        >
          <TimeoutProvider
            data-plasmic-name={"cooldownProvider"}
            data-plasmic-override={overrides.cooldownProvider}
            delay={1000}
            leadingRepeat={false}
            onTimeout={async () => {
              const $steps = {};

              $steps["updateCooldownV2"] = true
                ? (() => {
                    const actionArgs = {
                      variable: {
                        objRoot: $state,
                        variablePath: ["cooldown"]
                      },
                      operation: 0,
                      value: (() => {
                        function decrementCooldown(cooldownObj) {
                          Object.keys(cooldownObj).forEach(key => {
                            if (cooldownObj[key] > 0) {
                              cooldownObj[key]--;
                            }
                          });
                          return cooldownObj;
                        }
                        return decrementCooldown($state.cooldown);
                      })()
                    };
                    return (({ variable, value, startIndex, deleteCount }) => {
                      if (!variable) {
                        return;
                      }
                      const { objRoot, variablePath } = variable;

                      $stateSet(objRoot, variablePath, value);
                      return value;
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["updateCooldownV2"] != null &&
                typeof $steps["updateCooldownV2"] === "object" &&
                typeof $steps["updateCooldownV2"].then === "function"
              ) {
                $steps["updateCooldownV2"] = await $steps["updateCooldownV2"];
              }
            }}
            ref={ref => {
              $refs["cooldownProvider"] = ref;
            }}
            repeat={(() => {
              try {
                return Object.values($state.cooldown).some(value => value > 0);
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return false;
                }
                throw e;
              }
            })()}
          />

          <StateProvider
            data-plasmic-name={"deliveryMethod"}
            data-plasmic-override={overrides.deliveryMethod}
            defaultValue={(() => {
              try {
                return (() => {
                  const factors = $state.factors;
                  return factors.length > 0
                    ? factors.find(factor => factor.default).value
                    : null;
                })();
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return undefined;
                }
                throw e;
              }
            })()}
            onChange={async (...eventArgs: any) => {
              generateStateOnChangeProp($state, [
                "deliveryMethod",
                "value"
              ]).apply(null, eventArgs);
            }}
            value={generateStateValueProp($state, ["deliveryMethod", "value"])}
          />

          <div
            data-plasmic-name={"modal"}
            data-plasmic-override={overrides.modal}
            className={classNames(projectcss.all, sty.modal)}
            onKeyUp={async event => {
              const $steps = {};

              $steps["runCode"] = true
                ? (() => {
                    const actionArgs = {
                      customFunction: async () => {
                        return (() => {
                          event.preventDefault();
                          if (event.keyCode === 13) {
                            return document
                              .getElementById("submit-btn")
                              .click();
                          }
                        })();
                      }
                    };
                    return (({ customFunction }) => {
                      return customFunction();
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runCode"] != null &&
                typeof $steps["runCode"] === "object" &&
                typeof $steps["runCode"].then === "function"
              ) {
                $steps["runCode"] = await $steps["runCode"];
              }
            }}
          >
            <FormProvider
              data-plasmic-name={"formProvider"}
              data-plasmic-override={overrides.formProvider}
              className={classNames("__wab_instance", sty.formProvider)}
              contextName={"form"}
              mode={"all"}
              reValidateMode={"onChange"}
              zodValidationSchema={(() => {
                try {
                  return (() => {
                    const z = $$.zod();
                    const schema = z.object({
                      authCode: z
                        .string()
                        .nonempty({
                          message: "You must provide the authentication code."
                        })
                        .regex(/^\d+$/, {
                          message:
                            "The authentication code must consist of only digits."
                        })
                        .regex(/^\d{6}$/, {
                          message:
                            "The authentication code must consist of exactly 6 digits."
                        })
                        .default(""),
                      password: z
                        .string()
                        .nonempty({ message: "You must provide the password." })
                        .default("")
                    });
                    return schema;
                  })();
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
            >
              <DataCtxReader__>
                {$ctx => (
                  <div
                    data-plasmic-name={"top"}
                    data-plasmic-override={overrides.top}
                    className={classNames(projectcss.all, sty.top)}
                  >
                    <div
                      data-plasmic-name={"header"}
                      data-plasmic-override={overrides.header}
                      className={classNames(projectcss.all, sty.header)}
                    >
                      <div
                        data-plasmic-name={"titleWrapper"}
                        data-plasmic-override={overrides.titleWrapper}
                        className={classNames(projectcss.all, sty.titleWrapper)}
                      >
                        <DialogTitle
                          data-plasmic-name={"dialogTitle"}
                          data-plasmic-override={overrides.dialogTitle}
                          className={classNames(
                            "__wab_instance",
                            sty.dialogTitle
                          )}
                        >
                          <h4
                            data-plasmic-name={"h4"}
                            data-plasmic-override={overrides.h4}
                            className={classNames(
                              projectcss.all,
                              projectcss.h4,
                              projectcss.__wab_text,
                              sty.h4
                            )}
                          >
                            {"Multi-Factor Authentication"}
                          </h4>
                        </DialogTitle>
                      </div>
                      <DialogClose
                        data-plasmic-name={"dialogClose"}
                        data-plasmic-override={overrides.dialogClose}
                        className={classNames(
                          "__wab_instance",
                          sty.dialogClose
                        )}
                      >
                        <ModalCloseButton
                          data-plasmic-name={"modalCloseButton"}
                          data-plasmic-override={overrides.modalCloseButton}
                          className={classNames(
                            "__wab_instance",
                            sty.modalCloseButton
                          )}
                          onClick={async () => {
                            const $steps = {};

                            $steps["updateDialogCoreOpen"] = true
                              ? (() => {
                                  const actionArgs = {
                                    variable: {
                                      objRoot: $state,
                                      variablePath: ["dialogCore", "open"]
                                    },
                                    operation: 0,
                                    value: false
                                  };
                                  return (({
                                    variable,
                                    value,
                                    startIndex,
                                    deleteCount
                                  }) => {
                                    if (!variable) {
                                      return;
                                    }
                                    const { objRoot, variablePath } = variable;

                                    $stateSet(objRoot, variablePath, value);
                                    return value;
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["updateDialogCoreOpen"] != null &&
                              typeof $steps["updateDialogCoreOpen"] ===
                                "object" &&
                              typeof $steps["updateDialogCoreOpen"].then ===
                                "function"
                            ) {
                              $steps["updateDialogCoreOpen"] =
                                await $steps["updateDialogCoreOpen"];
                            }
                          }}
                        />
                      </DialogClose>
                    </div>
                    {(() => {
                      try {
                        return !$state.methodSelected;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return true;
                        }
                        throw e;
                      }
                    })() ? (
                      <div
                        data-plasmic-name={"methodSelect"}
                        data-plasmic-override={overrides.methodSelect}
                        className={classNames(projectcss.all, sty.methodSelect)}
                      >
                        <div
                          data-plasmic-name={"body2"}
                          data-plasmic-override={overrides.body2}
                          className={classNames(projectcss.all, sty.body2)}
                        >
                          <div
                            data-plasmic-name={"heading2"}
                            data-plasmic-override={overrides.heading2}
                            className={classNames(projectcss.all, sty.heading2)}
                          >
                            <h2
                              className={classNames(
                                projectcss.all,
                                projectcss.h2,
                                projectcss.__wab_text,
                                sty.h2__kVhuR
                              )}
                            >
                              {"Choose Delivery Method"}
                            </h2>
                            {(() => {
                              try {
                                return $state.factors.length > 1;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return false;
                                }
                                throw e;
                              }
                            })() ? (
                              <div
                                data-plasmic-name={
                                  "initialDeliveryMethodWrapper"
                                }
                                data-plasmic-override={
                                  overrides.initialDeliveryMethodWrapper
                                }
                                className={classNames(
                                  projectcss.all,
                                  sty.initialDeliveryMethodWrapper
                                )}
                              >
                                <p
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.p,
                                    projectcss.__wab_text,
                                    sty.p__k1Qil
                                  )}
                                >
                                  {
                                    "Select your preferred method to receive the authentication code"
                                  }
                                </p>
                                <ButtonBar
                                  data-plasmic-name={"buttonBar2"}
                                  data-plasmic-override={overrides.buttonBar2}
                                  className={classNames(
                                    "__wab_instance",
                                    sty.buttonBar2
                                  )}
                                  onValueChange={async (...eventArgs: any) => {
                                    generateStateOnChangeProp($state, [
                                      "buttonBar2",
                                      "value"
                                    ]).apply(null, eventArgs);

                                    if (
                                      eventArgs.length > 1 &&
                                      eventArgs[1] &&
                                      eventArgs[1]._plasmic_state_init_
                                    ) {
                                      return;
                                    }

                                    (async val => {
                                      const $steps = {};

                                      $steps["updateDeliveryMethodValue"] = true
                                        ? (() => {
                                            const actionArgs = {
                                              variable: {
                                                objRoot: $state,
                                                variablePath: [
                                                  "deliveryMethod",
                                                  "value"
                                                ]
                                              },
                                              operation: 0,
                                              value: val
                                            };
                                            return (({
                                              variable,
                                              value,
                                              startIndex,
                                              deleteCount
                                            }) => {
                                              if (!variable) {
                                                return;
                                              }
                                              const { objRoot, variablePath } =
                                                variable;

                                              $stateSet(
                                                objRoot,
                                                variablePath,
                                                value
                                              );
                                              return value;
                                            })?.apply(null, [actionArgs]);
                                          })()
                                        : undefined;
                                      if (
                                        $steps["updateDeliveryMethodValue"] !=
                                          null &&
                                        typeof $steps[
                                          "updateDeliveryMethodValue"
                                        ] === "object" &&
                                        typeof $steps[
                                          "updateDeliveryMethodValue"
                                        ].then === "function"
                                      ) {
                                        $steps["updateDeliveryMethodValue"] =
                                          await $steps[
                                            "updateDeliveryMethodValue"
                                          ];
                                      }
                                    }).apply(null, eventArgs);
                                  }}
                                  options={(() => {
                                    try {
                                      return (() => {
                                        const factorLabels = {
                                          Email: "Email Address",
                                          SMS: "SMS Message",
                                          Password: "Password"
                                        };
                                        return $state.factors
                                          .sort((a, b) =>
                                            a.default === b.default
                                              ? 0
                                              : a.default
                                                ? -1
                                                : 1
                                          )
                                          .map(factor => {
                                            const label =
                                              factorLabels[factor.value];
                                            return {
                                              ...factor,
                                              label,
                                              tooltip: `Change the verification method to ${label}`
                                            };
                                          });
                                      })();
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return undefined;
                                      }
                                      throw e;
                                    }
                                  })()}
                                  value={generateStateValueProp($state, [
                                    "buttonBar2",
                                    "value"
                                  ])}
                                />
                              </div>
                            ) : null}
                          </div>
                          <div
                            data-plasmic-name={"footer2"}
                            data-plasmic-override={overrides.footer2}
                            className={classNames(projectcss.all, sty.footer2)}
                          >
                            <div
                              data-plasmic-name={"buttons2"}
                              data-plasmic-override={overrides.buttons2}
                              className={classNames(
                                projectcss.all,
                                sty.buttons2
                              )}
                            >
                              <Button
                                className={classNames(
                                  "__wab_instance",
                                  sty.button__hSab
                                )}
                                color={"primary"}
                                id={"select-method-btn"}
                                onClick={async event => {
                                  const $steps = {};

                                  $steps["updateMethodSelected"] = true
                                    ? (() => {
                                        const actionArgs = {
                                          variable: {
                                            objRoot: $state,
                                            variablePath: ["methodSelected"]
                                          },
                                          operation: 0,
                                          value: true
                                        };
                                        return (({
                                          variable,
                                          value,
                                          startIndex,
                                          deleteCount
                                        }) => {
                                          if (!variable) {
                                            return;
                                          }
                                          const { objRoot, variablePath } =
                                            variable;

                                          $stateSet(
                                            objRoot,
                                            variablePath,
                                            value
                                          );
                                          return value;
                                        })?.apply(null, [actionArgs]);
                                      })()
                                    : undefined;
                                  if (
                                    $steps["updateMethodSelected"] != null &&
                                    typeof $steps["updateMethodSelected"] ===
                                      "object" &&
                                    typeof $steps["updateMethodSelected"]
                                      .then === "function"
                                  ) {
                                    $steps["updateMethodSelected"] =
                                      await $steps["updateMethodSelected"];
                                  }

                                  $steps["runCode"] =
                                    $state.deliveryMethod.value != "Password"
                                      ? (() => {
                                          const actionArgs = {
                                            customFunction: async () => {
                                              return (() => {
                                                const deliveryMethod =
                                                  $state.deliveryMethod?.value;
                                                $state.cooldown[
                                                  deliveryMethod
                                                ] = 30;
                                                return $props.onVerify(
                                                  "",
                                                  deliveryMethod
                                                );
                                              })();
                                            }
                                          };
                                          return (({ customFunction }) => {
                                            return customFunction();
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                  if (
                                    $steps["runCode"] != null &&
                                    typeof $steps["runCode"] === "object" &&
                                    typeof $steps["runCode"].then === "function"
                                  ) {
                                    $steps["runCode"] = await $steps["runCode"];
                                  }
                                }}
                                size={"medium"}
                              >
                                {(() => {
                                  try {
                                    return !$state.isChallengeSubmitting;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return true;
                                    }
                                    throw e;
                                  }
                                })() ? (
                                  <div
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.__wab_text,
                                      sty.text__ioPt9
                                    )}
                                  >
                                    {"Select"}
                                  </div>
                                ) : null}
                                {(() => {
                                  try {
                                    return $state.isChallengeSubmitting;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return true;
                                    }
                                    throw e;
                                  }
                                })() ? (
                                  <SpinnerIcon
                                    className={classNames(
                                      "__wab_instance",
                                      sty.spinnerIcon__juNJw
                                    )}
                                    light={true}
                                  />
                                ) : null}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {(() => {
                      try {
                        return $state.methodSelected;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return false;
                        }
                        throw e;
                      }
                    })() ? (
                      <div
                        data-plasmic-name={"selectedMethod"}
                        data-plasmic-override={overrides.selectedMethod}
                        className={classNames(
                          projectcss.all,
                          sty.selectedMethod
                        )}
                      >
                        <FormControlProvider
                          data-plasmic-name={"authCodeProvider"}
                          data-plasmic-override={overrides.authCodeProvider}
                          className={classNames(
                            "__wab_instance",
                            sty.authCodeProvider
                          )}
                          contextName={"authCodeProvider"}
                          fieldName={"authCode"}
                          formControl={(() => {
                            try {
                              return $ctx.form.control;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <DataCtxReader__>
                            {$ctx => (
                              <FormControlProvider
                                data-plasmic-name={"passwordProvider"}
                                data-plasmic-override={
                                  overrides.passwordProvider
                                }
                                className={classNames(
                                  "__wab_instance",
                                  sty.passwordProvider
                                )}
                                contextName={"passwordProvider"}
                                fieldName={"password"}
                                formControl={(() => {
                                  try {
                                    return $ctx.form.control;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return undefined;
                                    }
                                    throw e;
                                  }
                                })()}
                              >
                                <DataCtxReader__>
                                  {$ctx => (
                                    <div
                                      data-plasmic-name={"body"}
                                      data-plasmic-override={overrides.body}
                                      className={classNames(
                                        projectcss.all,
                                        sty.body
                                      )}
                                    >
                                      <div
                                        data-plasmic-name={"heading"}
                                        data-plasmic-override={
                                          overrides.heading
                                        }
                                        className={classNames(
                                          projectcss.all,
                                          sty.heading
                                        )}
                                      >
                                        <h2
                                          className={classNames(
                                            projectcss.all,
                                            projectcss.h2,
                                            projectcss.__wab_text,
                                            sty.h2__a76Oi
                                          )}
                                        >
                                          {"Verify Your Identity"}
                                        </h2>
                                        {(() => {
                                          try {
                                            return $state.factors.length > 1;
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return false;
                                            }
                                            throw e;
                                          }
                                        })() ? (
                                          <div
                                            data-plasmic-name={
                                              "deliveryMethodWrapper"
                                            }
                                            data-plasmic-override={
                                              overrides.deliveryMethodWrapper
                                            }
                                            className={classNames(
                                              projectcss.all,
                                              sty.deliveryMethodWrapper
                                            )}
                                          >
                                            <ButtonBar
                                              data-plasmic-name={"buttonBar"}
                                              data-plasmic-override={
                                                overrides.buttonBar
                                              }
                                              className={classNames(
                                                "__wab_instance",
                                                sty.buttonBar
                                              )}
                                              onValueChange={async (
                                                ...eventArgs: any
                                              ) => {
                                                generateStateOnChangeProp(
                                                  $state,
                                                  ["buttonBar", "value"]
                                                ).apply(null, eventArgs);

                                                if (
                                                  eventArgs.length > 1 &&
                                                  eventArgs[1] &&
                                                  eventArgs[1]
                                                    ._plasmic_state_init_
                                                ) {
                                                  return;
                                                }

                                                (async val => {
                                                  const $steps = {};

                                                  $steps["runCode"] =
                                                    $state.buttonBar.value !=
                                                    $state.deliveryMethod.value
                                                      ? (() => {
                                                          const actionArgs = {
                                                            customFunction:
                                                              async () => {
                                                                return (() => {
                                                                  $state.deliveryMethod.value =
                                                                    val;
                                                                  const deliveryMethod =
                                                                    $state
                                                                      .deliveryMethod
                                                                      ?.value;
                                                                  if (
                                                                    deliveryMethod ===
                                                                    "Password"
                                                                  ) {
                                                                    return;
                                                                  }
                                                                  if (
                                                                    !$state
                                                                      .cooldown[
                                                                      deliveryMethod
                                                                    ] > 0
                                                                  ) {
                                                                    $state.cooldown[
                                                                      deliveryMethod
                                                                    ] = 30;
                                                                    $props.onVerify(
                                                                      "",
                                                                      deliveryMethod
                                                                    );
                                                                    return;
                                                                  }
                                                                  return $ctx.toast.show(
                                                                    {
                                                                      type: "info",
                                                                      duration: 5000,
                                                                      title:
                                                                        "Code Already Sent",
                                                                      description:
                                                                        "Please check your selected delivery method for authentication code"
                                                                    }
                                                                  );
                                                                })();
                                                              }
                                                          };
                                                          return (({
                                                            customFunction
                                                          }) => {
                                                            return customFunction();
                                                          })?.apply(null, [
                                                            actionArgs
                                                          ]);
                                                        })()
                                                      : undefined;
                                                  if (
                                                    $steps["runCode"] != null &&
                                                    typeof $steps["runCode"] ===
                                                      "object" &&
                                                    typeof $steps["runCode"]
                                                      .then === "function"
                                                  ) {
                                                    $steps["runCode"] =
                                                      await $steps["runCode"];
                                                  }
                                                }).apply(null, eventArgs);
                                              }}
                                              options={(() => {
                                                try {
                                                  return (() => {
                                                    const factorLabels = {
                                                      Email: "Email Address",
                                                      SMS: "SMS Message",
                                                      Password: "Password"
                                                    };
                                                    return $state.factors
                                                      .sort((a, b) =>
                                                        a.default === b.default
                                                          ? 0
                                                          : a.default
                                                            ? -1
                                                            : 1
                                                      )
                                                      .map(factor => {
                                                        const label =
                                                          factorLabels[
                                                            factor.value
                                                          ];
                                                        return {
                                                          ...factor,
                                                          label,
                                                          tooltip: `Change the verification method to ${label}`
                                                        };
                                                      });
                                                  })();
                                                } catch (e) {
                                                  if (
                                                    e instanceof TypeError ||
                                                    e?.plasmicType ===
                                                      "PlasmicUndefinedDataError"
                                                  ) {
                                                    return undefined;
                                                  }
                                                  throw e;
                                                }
                                              })()}
                                              value={generateStateValueProp(
                                                $state,
                                                ["buttonBar", "value"]
                                              )}
                                            />
                                          </div>
                                        ) : null}
                                      </div>
                                      <div
                                        data-plasmic-name={"inputWrapper"}
                                        data-plasmic-override={
                                          overrides.inputWrapper
                                        }
                                        className={classNames(
                                          projectcss.all,
                                          sty.inputWrapper
                                        )}
                                      >
                                        <p
                                          className={classNames(
                                            projectcss.all,
                                            projectcss.p,
                                            projectcss.__wab_text,
                                            sty.p___1KCvc
                                          )}
                                        >
                                          <React.Fragment>{`Enter your ${$state.deliveryMethod.value === "Password" ? "password" : "verification code"} to complete the ${$props.action}.`}</React.Fragment>
                                        </p>
                                        {(() => {
                                          try {
                                            return (
                                              $state.deliveryMethod.value !=
                                              "Password"
                                            );
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return false;
                                            }
                                            throw e;
                                          }
                                        })() ? (
                                          <div
                                            data-plasmic-name={
                                              "codeInputWrapper"
                                            }
                                            data-plasmic-override={
                                              overrides.codeInputWrapper
                                            }
                                            className={classNames(
                                              projectcss.all,
                                              sty.codeInputWrapper
                                            )}
                                          >
                                            {(() => {
                                              const child$Props = {
                                                "aria-label":
                                                  "Authentication Code Input",
                                                "aria-labelledby":
                                                  "Authentication Code Input",
                                                autoComplete: "off",
                                                autoFocus: true,
                                                className: classNames(
                                                  "__wab_instance",
                                                  sty.authCodeInput
                                                ),
                                                inputMode: "numeric",
                                                invalid: (() => {
                                                  try {
                                                    return $ctx.authCodeProvider
                                                      .fieldState.invalid;
                                                  } catch (e) {
                                                    if (
                                                      e instanceof TypeError ||
                                                      e?.plasmicType ===
                                                        "PlasmicUndefinedDataError"
                                                    ) {
                                                      return [];
                                                    }
                                                    throw e;
                                                  }
                                                })(),
                                                name: "authCode",
                                                onChange: async (
                                                  ...eventArgs: any
                                                ) => {
                                                  ((...eventArgs) => {
                                                    generateStateOnChangeProp(
                                                      $state,
                                                      ["authCodeInput", "value"]
                                                    )(
                                                      (e =>
                                                        e.target?.value).apply(
                                                        null,
                                                        eventArgs
                                                      )
                                                    );
                                                  }).apply(null, eventArgs);

                                                  if (
                                                    eventArgs.length > 1 &&
                                                    eventArgs[1] &&
                                                    eventArgs[1]
                                                      ._plasmic_state_init_
                                                  ) {
                                                    return;
                                                  }

                                                  (async event => {
                                                    const $steps = {};

                                                    $steps["runCode"] = true
                                                      ? (() => {
                                                          const actionArgs = {
                                                            customFunction:
                                                              async () => {
                                                                return (() => {
                                                                  return $ctx.authCodeProvider.field.onChange(
                                                                    event.target
                                                                      .value
                                                                  );
                                                                })();
                                                              }
                                                          };
                                                          return (({
                                                            customFunction
                                                          }) => {
                                                            return customFunction();
                                                          })?.apply(null, [
                                                            actionArgs
                                                          ]);
                                                        })()
                                                      : undefined;
                                                    if (
                                                      $steps["runCode"] !=
                                                        null &&
                                                      typeof $steps[
                                                        "runCode"
                                                      ] === "object" &&
                                                      typeof $steps["runCode"]
                                                        .then === "function"
                                                    ) {
                                                      $steps["runCode"] =
                                                        await $steps["runCode"];
                                                    }
                                                  }).apply(null, eventArgs);
                                                },
                                                placeholder:
                                                  "6-digit authentication code",
                                                required: false,
                                                size: "large",
                                                type: "text",
                                                value:
                                                  generateStateValueProp(
                                                    $state,
                                                    ["authCodeInput", "value"]
                                                  ) ?? ""
                                              };

                                              initializePlasmicStates(
                                                $state,
                                                [
                                                  {
                                                    name: "authCodeInput.value",
                                                    initFunc: ({
                                                      $props,
                                                      $state,
                                                      $queries
                                                    }) =>
                                                      (() => {
                                                        try {
                                                          return $ctx
                                                            .authCodeProvider
                                                            .field.value;
                                                        } catch (e) {
                                                          if (
                                                            e instanceof
                                                              TypeError ||
                                                            e?.plasmicType ===
                                                              "PlasmicUndefinedDataError"
                                                          ) {
                                                            return undefined;
                                                          }
                                                          throw e;
                                                        }
                                                      })()
                                                  }
                                                ],
                                                []
                                              );
                                              return (
                                                <TextInput
                                                  data-plasmic-name={
                                                    "authCodeInput"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.authCodeInput
                                                  }
                                                  {...child$Props}
                                                />
                                              );
                                            })()}
                                          </div>
                                        ) : null}
                                        {(() => {
                                          try {
                                            return (
                                              $state.deliveryMethod.value !=
                                              "Password"
                                            );
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return false;
                                            }
                                            throw e;
                                          }
                                        })() ? (
                                          <div
                                            data-plasmic-name={
                                              "authCodeErrorContainer"
                                            }
                                            data-plasmic-override={
                                              overrides.authCodeErrorContainer
                                            }
                                            className={classNames(
                                              projectcss.all,
                                              sty.authCodeErrorContainer
                                            )}
                                          >
                                            {(() => {
                                              try {
                                                return $ctx.authCodeProvider
                                                  .fieldState.invalid;
                                              } catch (e) {
                                                if (
                                                  e instanceof TypeError ||
                                                  e?.plasmicType ===
                                                    "PlasmicUndefinedDataError"
                                                ) {
                                                  return false;
                                                }
                                                throw e;
                                              }
                                            })() ? (
                                              <span
                                                className={classNames(
                                                  projectcss.all,
                                                  projectcss.span,
                                                  projectcss.__wab_text,
                                                  sty.span__fm7Ce
                                                )}
                                              >
                                                <React.Fragment>
                                                  {
                                                    $ctx.authCodeProvider
                                                      .fieldState.error.message
                                                  }
                                                </React.Fragment>
                                              </span>
                                            ) : null}
                                          </div>
                                        ) : null}
                                        {(() => {
                                          try {
                                            return (
                                              $state.deliveryMethod.value ===
                                              "Password"
                                            );
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return false;
                                            }
                                            throw e;
                                          }
                                        })() ? (
                                          <div
                                            data-plasmic-name={
                                              "passwordInputWrapper"
                                            }
                                            data-plasmic-override={
                                              overrides.passwordInputWrapper
                                            }
                                            className={classNames(
                                              projectcss.all,
                                              sty.passwordInputWrapper
                                            )}
                                          >
                                            {(() => {
                                              const child$Props = {
                                                "aria-label": "Password Input",
                                                "aria-labelledby":
                                                  "Password Input",
                                                autoComplete: "off",
                                                autoFocus: true,
                                                className: classNames(
                                                  "__wab_instance",
                                                  sty.passwordInput
                                                ),
                                                inputMode: "text",
                                                invalid: (() => {
                                                  try {
                                                    return $ctx.passwordProvider
                                                      .fieldState.invalid;
                                                  } catch (e) {
                                                    if (
                                                      e instanceof TypeError ||
                                                      e?.plasmicType ===
                                                        "PlasmicUndefinedDataError"
                                                    ) {
                                                      return [];
                                                    }
                                                    throw e;
                                                  }
                                                })(),
                                                name: "password",
                                                onChange: async (
                                                  ...eventArgs: any
                                                ) => {
                                                  ((...eventArgs) => {
                                                    generateStateOnChangeProp(
                                                      $state,
                                                      ["passwordInput", "value"]
                                                    )(
                                                      (e =>
                                                        e.target?.value).apply(
                                                        null,
                                                        eventArgs
                                                      )
                                                    );
                                                  }).apply(null, eventArgs);

                                                  if (
                                                    eventArgs.length > 1 &&
                                                    eventArgs[1] &&
                                                    eventArgs[1]
                                                      ._plasmic_state_init_
                                                  ) {
                                                    return;
                                                  }

                                                  (async event => {
                                                    const $steps = {};

                                                    $steps["runCode"] = true
                                                      ? (() => {
                                                          const actionArgs = {
                                                            customFunction:
                                                              async () => {
                                                                return (() => {
                                                                  return $ctx.passwordProvider.field.onChange(
                                                                    event.target
                                                                      .value
                                                                  );
                                                                })();
                                                              }
                                                          };
                                                          return (({
                                                            customFunction
                                                          }) => {
                                                            return customFunction();
                                                          })?.apply(null, [
                                                            actionArgs
                                                          ]);
                                                        })()
                                                      : undefined;
                                                    if (
                                                      $steps["runCode"] !=
                                                        null &&
                                                      typeof $steps[
                                                        "runCode"
                                                      ] === "object" &&
                                                      typeof $steps["runCode"]
                                                        .then === "function"
                                                    ) {
                                                      $steps["runCode"] =
                                                        await $steps["runCode"];
                                                    }
                                                  }).apply(null, eventArgs);
                                                },
                                                placeholder: "Password",
                                                required: false,
                                                size: "large",
                                                type: "password",
                                                value:
                                                  generateStateValueProp(
                                                    $state,
                                                    ["passwordInput", "value"]
                                                  ) ?? ""
                                              };

                                              initializePlasmicStates(
                                                $state,
                                                [
                                                  {
                                                    name: "passwordInput.value",
                                                    initFunc: ({
                                                      $props,
                                                      $state,
                                                      $queries
                                                    }) =>
                                                      (() => {
                                                        try {
                                                          return $ctx
                                                            .passwordProvider
                                                            .field.value;
                                                        } catch (e) {
                                                          if (
                                                            e instanceof
                                                              TypeError ||
                                                            e?.plasmicType ===
                                                              "PlasmicUndefinedDataError"
                                                          ) {
                                                            return undefined;
                                                          }
                                                          throw e;
                                                        }
                                                      })()
                                                  }
                                                ],
                                                []
                                              );
                                              return (
                                                <TextInput
                                                  data-plasmic-name={
                                                    "passwordInput"
                                                  }
                                                  data-plasmic-override={
                                                    overrides.passwordInput
                                                  }
                                                  {...child$Props}
                                                />
                                              );
                                            })()}
                                            <div
                                              data-plasmic-name={
                                                "passwordErrorContainer"
                                              }
                                              data-plasmic-override={
                                                overrides.passwordErrorContainer
                                              }
                                              className={classNames(
                                                projectcss.all,
                                                sty.passwordErrorContainer
                                              )}
                                            >
                                              {(() => {
                                                try {
                                                  return $ctx.passwordProvider
                                                    .fieldState.invalid;
                                                } catch (e) {
                                                  if (
                                                    e instanceof TypeError ||
                                                    e?.plasmicType ===
                                                      "PlasmicUndefinedDataError"
                                                  ) {
                                                    return false;
                                                  }
                                                  throw e;
                                                }
                                              })() ? (
                                                <span
                                                  className={classNames(
                                                    projectcss.all,
                                                    projectcss.span,
                                                    projectcss.__wab_text,
                                                    sty.span__pTm6
                                                  )}
                                                >
                                                  <React.Fragment>
                                                    {
                                                      $ctx.passwordProvider
                                                        .fieldState.error
                                                        .message
                                                    }
                                                  </React.Fragment>
                                                </span>
                                              ) : null}
                                            </div>
                                          </div>
                                        ) : null}
                                      </div>
                                      <div
                                        data-plasmic-name={"footer"}
                                        data-plasmic-override={overrides.footer}
                                        className={classNames(
                                          projectcss.all,
                                          sty.footer
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"buttons"}
                                          data-plasmic-override={
                                            overrides.buttons
                                          }
                                          className={classNames(
                                            projectcss.all,
                                            sty.buttons
                                          )}
                                        >
                                          <Button
                                            className={classNames(
                                              "__wab_instance",
                                              sty.button__e465U
                                            )}
                                            color={"primary"}
                                            id={"submit-btn"}
                                            onClick={async event => {
                                              const $steps = {};

                                              $steps["runCode"] = (
                                                $state.deliveryMethod.value !=
                                                "Password"
                                                  ? !$ctx.authCodeProvider
                                                      .fieldState.invalid &&
                                                    $state.authCodeInput?.value
                                                      ?.length > 0
                                                  : !$ctx.passwordProvider
                                                      .fieldState.invalid &&
                                                    $state.passwordInput?.value
                                                      ?.length > 0
                                              )
                                                ? (() => {
                                                    const actionArgs = {
                                                      customFunction:
                                                        async () => {
                                                          return (async () => {
                                                            $state.isChallengeSubmitting = true;
                                                            const input =
                                                              $state
                                                                .authCodeInput
                                                                .value ??
                                                              $state
                                                                .passwordInput
                                                                .value;
                                                            async function verifyChallenge() {
                                                              try {
                                                                await $props.onVerify(
                                                                  input,
                                                                  $state
                                                                    .deliveryMethod
                                                                    ?.value
                                                                );
                                                              } catch (error) {
                                                                console.error(
                                                                  error
                                                                );
                                                                $state.isChallengeSubmitting = false;
                                                              }
                                                            }
                                                            return verifyChallenge();
                                                          })();
                                                        }
                                                    };
                                                    return (({
                                                      customFunction
                                                    }) => {
                                                      return customFunction();
                                                    })?.apply(null, [
                                                      actionArgs
                                                    ]);
                                                  })()
                                                : undefined;
                                              if (
                                                $steps["runCode"] != null &&
                                                typeof $steps["runCode"] ===
                                                  "object" &&
                                                typeof $steps["runCode"]
                                                  .then === "function"
                                              ) {
                                                $steps["runCode"] =
                                                  await $steps["runCode"];
                                              }
                                            }}
                                            size={"medium"}
                                          >
                                            {(() => {
                                              try {
                                                return !$state.isChallengeSubmitting;
                                              } catch (e) {
                                                if (
                                                  e instanceof TypeError ||
                                                  e?.plasmicType ===
                                                    "PlasmicUndefinedDataError"
                                                ) {
                                                  return true;
                                                }
                                                throw e;
                                              }
                                            })() ? (
                                              <div
                                                className={classNames(
                                                  projectcss.all,
                                                  projectcss.__wab_text,
                                                  sty.text__zymUe
                                                )}
                                              >
                                                {"Submit"}
                                              </div>
                                            ) : null}
                                            {(() => {
                                              try {
                                                return $state.isChallengeSubmitting;
                                              } catch (e) {
                                                if (
                                                  e instanceof TypeError ||
                                                  e?.plasmicType ===
                                                    "PlasmicUndefinedDataError"
                                                ) {
                                                  return true;
                                                }
                                                throw e;
                                              }
                                            })() ? (
                                              <SpinnerIcon
                                                className={classNames(
                                                  "__wab_instance",
                                                  sty.spinnerIcon__x0L5V
                                                )}
                                                light={true}
                                              />
                                            ) : null}
                                          </Button>
                                        </div>
                                        {(() => {
                                          try {
                                            return (
                                              $state.deliveryMethod.value !=
                                              "Password"
                                            );
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return true;
                                            }
                                            throw e;
                                          }
                                        })() ? (
                                          <div
                                            data-plasmic-name={"bottom"}
                                            data-plasmic-override={
                                              overrides.bottom
                                            }
                                            className={classNames(
                                              projectcss.all,
                                              sty.bottom
                                            )}
                                          >
                                            <p
                                              className={classNames(
                                                projectcss.all,
                                                projectcss.p,
                                                projectcss.__wab_text,
                                                sty.p__fo3MQ
                                              )}
                                            >
                                              {"Didn't receive the code?"}
                                            </p>
                                            <Button
                                              aria-label={"Resend Code"}
                                              className={classNames(
                                                "__wab_instance",
                                                sty.button___8229P
                                              )}
                                              color={"sky"}
                                              isDisabled={(() => {
                                                try {
                                                  return (
                                                    $state.cooldown[
                                                      $state.deliveryMethod
                                                        ?.value
                                                    ] > 0
                                                  );
                                                } catch (e) {
                                                  if (
                                                    e instanceof TypeError ||
                                                    e?.plasmicType ===
                                                      "PlasmicUndefinedDataError"
                                                  ) {
                                                    return [];
                                                  }
                                                  throw e;
                                                }
                                              })()}
                                              onClick={async event => {
                                                const $steps = {};

                                                $steps["runCode"] = true
                                                  ? (() => {
                                                      const actionArgs = {
                                                        customFunction:
                                                          async () => {
                                                            return (() => {
                                                              $state.cooldown[
                                                                $state.deliveryMethod.value
                                                              ] = 30;
                                                              return $props.onVerify(
                                                                "",
                                                                $state
                                                                  .deliveryMethod
                                                                  ?.value
                                                              );
                                                            })();
                                                          }
                                                      };
                                                      return (({
                                                        customFunction
                                                      }) => {
                                                        return customFunction();
                                                      })?.apply(null, [
                                                        actionArgs
                                                      ]);
                                                    })()
                                                  : undefined;
                                                if (
                                                  $steps["runCode"] != null &&
                                                  typeof $steps["runCode"] ===
                                                    "object" &&
                                                  typeof $steps["runCode"]
                                                    .then === "function"
                                                ) {
                                                  $steps["runCode"] =
                                                    await $steps["runCode"];
                                                }
                                              }}
                                              size={"small"}
                                            >
                                              <div
                                                className={classNames(
                                                  projectcss.all,
                                                  projectcss.__wab_text,
                                                  sty.text__ovdfz
                                                )}
                                              >
                                                <React.Fragment>
                                                  {(() => {
                                                    try {
                                                      return (() => {
                                                        const cooldown =
                                                          $state.cooldown[
                                                            $state
                                                              .deliveryMethod
                                                              ?.value
                                                          ];
                                                        return cooldown > 0
                                                          ? `Resend Code (${cooldown})`
                                                          : "Resend Code";
                                                      })();
                                                    } catch (e) {
                                                      if (
                                                        e instanceof
                                                          TypeError ||
                                                        e?.plasmicType ===
                                                          "PlasmicUndefinedDataError"
                                                      ) {
                                                        return "Resend Code";
                                                      }
                                                      throw e;
                                                    }
                                                  })()}
                                                </React.Fragment>
                                              </div>
                                            </Button>
                                          </div>
                                        ) : null}
                                      </div>
                                    </div>
                                  )}
                                </DataCtxReader__>
                              </FormControlProvider>
                            )}
                          </DataCtxReader__>
                        </FormControlProvider>
                      </div>
                    ) : null}
                  </div>
                )}
              </DataCtxReader__>
            </FormProvider>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "dialogCore",
    "rawNull",
    "dialogContent",
    "cooldownProvider",
    "deliveryMethod",
    "modal",
    "formProvider",
    "top",
    "header",
    "titleWrapper",
    "dialogTitle",
    "h4",
    "dialogClose",
    "modalCloseButton",
    "methodSelect",
    "body2",
    "heading2",
    "initialDeliveryMethodWrapper",
    "buttonBar2",
    "footer2",
    "buttons2",
    "selectedMethod",
    "authCodeProvider",
    "passwordProvider",
    "body",
    "heading",
    "deliveryMethodWrapper",
    "buttonBar",
    "inputWrapper",
    "codeInputWrapper",
    "authCodeInput",
    "authCodeErrorContainer",
    "passwordInputWrapper",
    "passwordInput",
    "passwordErrorContainer",
    "footer",
    "buttons",
    "bottom"
  ],
  dialogCore: [
    "dialogCore",
    "rawNull",
    "dialogContent",
    "cooldownProvider",
    "deliveryMethod",
    "modal",
    "formProvider",
    "top",
    "header",
    "titleWrapper",
    "dialogTitle",
    "h4",
    "dialogClose",
    "modalCloseButton",
    "methodSelect",
    "body2",
    "heading2",
    "initialDeliveryMethodWrapper",
    "buttonBar2",
    "footer2",
    "buttons2",
    "selectedMethod",
    "authCodeProvider",
    "passwordProvider",
    "body",
    "heading",
    "deliveryMethodWrapper",
    "buttonBar",
    "inputWrapper",
    "codeInputWrapper",
    "authCodeInput",
    "authCodeErrorContainer",
    "passwordInputWrapper",
    "passwordInput",
    "passwordErrorContainer",
    "footer",
    "buttons",
    "bottom"
  ],
  rawNull: ["rawNull"],
  dialogContent: [
    "dialogContent",
    "cooldownProvider",
    "deliveryMethod",
    "modal",
    "formProvider",
    "top",
    "header",
    "titleWrapper",
    "dialogTitle",
    "h4",
    "dialogClose",
    "modalCloseButton",
    "methodSelect",
    "body2",
    "heading2",
    "initialDeliveryMethodWrapper",
    "buttonBar2",
    "footer2",
    "buttons2",
    "selectedMethod",
    "authCodeProvider",
    "passwordProvider",
    "body",
    "heading",
    "deliveryMethodWrapper",
    "buttonBar",
    "inputWrapper",
    "codeInputWrapper",
    "authCodeInput",
    "authCodeErrorContainer",
    "passwordInputWrapper",
    "passwordInput",
    "passwordErrorContainer",
    "footer",
    "buttons",
    "bottom"
  ],
  cooldownProvider: ["cooldownProvider"],
  deliveryMethod: ["deliveryMethod"],
  modal: [
    "modal",
    "formProvider",
    "top",
    "header",
    "titleWrapper",
    "dialogTitle",
    "h4",
    "dialogClose",
    "modalCloseButton",
    "methodSelect",
    "body2",
    "heading2",
    "initialDeliveryMethodWrapper",
    "buttonBar2",
    "footer2",
    "buttons2",
    "selectedMethod",
    "authCodeProvider",
    "passwordProvider",
    "body",
    "heading",
    "deliveryMethodWrapper",
    "buttonBar",
    "inputWrapper",
    "codeInputWrapper",
    "authCodeInput",
    "authCodeErrorContainer",
    "passwordInputWrapper",
    "passwordInput",
    "passwordErrorContainer",
    "footer",
    "buttons",
    "bottom"
  ],
  formProvider: [
    "formProvider",
    "top",
    "header",
    "titleWrapper",
    "dialogTitle",
    "h4",
    "dialogClose",
    "modalCloseButton",
    "methodSelect",
    "body2",
    "heading2",
    "initialDeliveryMethodWrapper",
    "buttonBar2",
    "footer2",
    "buttons2",
    "selectedMethod",
    "authCodeProvider",
    "passwordProvider",
    "body",
    "heading",
    "deliveryMethodWrapper",
    "buttonBar",
    "inputWrapper",
    "codeInputWrapper",
    "authCodeInput",
    "authCodeErrorContainer",
    "passwordInputWrapper",
    "passwordInput",
    "passwordErrorContainer",
    "footer",
    "buttons",
    "bottom"
  ],
  top: [
    "top",
    "header",
    "titleWrapper",
    "dialogTitle",
    "h4",
    "dialogClose",
    "modalCloseButton",
    "methodSelect",
    "body2",
    "heading2",
    "initialDeliveryMethodWrapper",
    "buttonBar2",
    "footer2",
    "buttons2",
    "selectedMethod",
    "authCodeProvider",
    "passwordProvider",
    "body",
    "heading",
    "deliveryMethodWrapper",
    "buttonBar",
    "inputWrapper",
    "codeInputWrapper",
    "authCodeInput",
    "authCodeErrorContainer",
    "passwordInputWrapper",
    "passwordInput",
    "passwordErrorContainer",
    "footer",
    "buttons",
    "bottom"
  ],
  header: [
    "header",
    "titleWrapper",
    "dialogTitle",
    "h4",
    "dialogClose",
    "modalCloseButton"
  ],
  titleWrapper: ["titleWrapper", "dialogTitle", "h4"],
  dialogTitle: ["dialogTitle", "h4"],
  h4: ["h4"],
  dialogClose: ["dialogClose", "modalCloseButton"],
  modalCloseButton: ["modalCloseButton"],
  methodSelect: [
    "methodSelect",
    "body2",
    "heading2",
    "initialDeliveryMethodWrapper",
    "buttonBar2",
    "footer2",
    "buttons2"
  ],
  body2: [
    "body2",
    "heading2",
    "initialDeliveryMethodWrapper",
    "buttonBar2",
    "footer2",
    "buttons2"
  ],
  heading2: ["heading2", "initialDeliveryMethodWrapper", "buttonBar2"],
  initialDeliveryMethodWrapper: ["initialDeliveryMethodWrapper", "buttonBar2"],
  buttonBar2: ["buttonBar2"],
  footer2: ["footer2", "buttons2"],
  buttons2: ["buttons2"],
  selectedMethod: [
    "selectedMethod",
    "authCodeProvider",
    "passwordProvider",
    "body",
    "heading",
    "deliveryMethodWrapper",
    "buttonBar",
    "inputWrapper",
    "codeInputWrapper",
    "authCodeInput",
    "authCodeErrorContainer",
    "passwordInputWrapper",
    "passwordInput",
    "passwordErrorContainer",
    "footer",
    "buttons",
    "bottom"
  ],
  authCodeProvider: [
    "authCodeProvider",
    "passwordProvider",
    "body",
    "heading",
    "deliveryMethodWrapper",
    "buttonBar",
    "inputWrapper",
    "codeInputWrapper",
    "authCodeInput",
    "authCodeErrorContainer",
    "passwordInputWrapper",
    "passwordInput",
    "passwordErrorContainer",
    "footer",
    "buttons",
    "bottom"
  ],
  passwordProvider: [
    "passwordProvider",
    "body",
    "heading",
    "deliveryMethodWrapper",
    "buttonBar",
    "inputWrapper",
    "codeInputWrapper",
    "authCodeInput",
    "authCodeErrorContainer",
    "passwordInputWrapper",
    "passwordInput",
    "passwordErrorContainer",
    "footer",
    "buttons",
    "bottom"
  ],
  body: [
    "body",
    "heading",
    "deliveryMethodWrapper",
    "buttonBar",
    "inputWrapper",
    "codeInputWrapper",
    "authCodeInput",
    "authCodeErrorContainer",
    "passwordInputWrapper",
    "passwordInput",
    "passwordErrorContainer",
    "footer",
    "buttons",
    "bottom"
  ],
  heading: ["heading", "deliveryMethodWrapper", "buttonBar"],
  deliveryMethodWrapper: ["deliveryMethodWrapper", "buttonBar"],
  buttonBar: ["buttonBar"],
  inputWrapper: [
    "inputWrapper",
    "codeInputWrapper",
    "authCodeInput",
    "authCodeErrorContainer",
    "passwordInputWrapper",
    "passwordInput",
    "passwordErrorContainer"
  ],
  codeInputWrapper: ["codeInputWrapper", "authCodeInput"],
  authCodeInput: ["authCodeInput"],
  authCodeErrorContainer: ["authCodeErrorContainer"],
  passwordInputWrapper: [
    "passwordInputWrapper",
    "passwordInput",
    "passwordErrorContainer"
  ],
  passwordInput: ["passwordInput"],
  passwordErrorContainer: ["passwordErrorContainer"],
  footer: ["footer", "buttons", "bottom"],
  buttons: ["buttons"],
  bottom: ["bottom"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  dialogCore: typeof Dialog;
  rawNull: typeof RawNull;
  dialogContent: typeof DialogContent;
  cooldownProvider: typeof TimeoutProvider;
  deliveryMethod: typeof StateProvider;
  modal: "div";
  formProvider: typeof FormProvider;
  top: "div";
  header: "div";
  titleWrapper: "div";
  dialogTitle: typeof DialogTitle;
  h4: "h4";
  dialogClose: typeof DialogClose;
  modalCloseButton: typeof ModalCloseButton;
  methodSelect: "div";
  body2: "div";
  heading2: "div";
  initialDeliveryMethodWrapper: "div";
  buttonBar2: typeof ButtonBar;
  footer2: "div";
  buttons2: "div";
  selectedMethod: "div";
  authCodeProvider: typeof FormControlProvider;
  passwordProvider: typeof FormControlProvider;
  body: "div";
  heading: "div";
  deliveryMethodWrapper: "div";
  buttonBar: typeof ButtonBar;
  inputWrapper: "div";
  codeInputWrapper: "div";
  authCodeInput: typeof TextInput;
  authCodeErrorContainer: "div";
  passwordInputWrapper: "div";
  passwordInput: typeof TextInput;
  passwordErrorContainer: "div";
  footer: "div";
  buttons: "div";
  bottom: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicMultiFactorAuthModal__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicMultiFactorAuthModal__VariantsArgs;
    args?: PlasmicMultiFactorAuthModal__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicMultiFactorAuthModal__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicMultiFactorAuthModal__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMultiFactorAuthModal__ArgProps,
          internalVariantPropNames: PlasmicMultiFactorAuthModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicMultiFactorAuthModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicMultiFactorAuthModal";
  } else {
    func.displayName = `PlasmicMultiFactorAuthModal.${nodeName}`;
  }
  return func;
}

export const PlasmicMultiFactorAuthModal = Object.assign(
  // Top-level PlasmicMultiFactorAuthModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    dialogCore: makeNodeComponent("dialogCore"),
    rawNull: makeNodeComponent("rawNull"),
    dialogContent: makeNodeComponent("dialogContent"),
    cooldownProvider: makeNodeComponent("cooldownProvider"),
    deliveryMethod: makeNodeComponent("deliveryMethod"),
    modal: makeNodeComponent("modal"),
    formProvider: makeNodeComponent("formProvider"),
    top: makeNodeComponent("top"),
    header: makeNodeComponent("header"),
    titleWrapper: makeNodeComponent("titleWrapper"),
    dialogTitle: makeNodeComponent("dialogTitle"),
    h4: makeNodeComponent("h4"),
    dialogClose: makeNodeComponent("dialogClose"),
    modalCloseButton: makeNodeComponent("modalCloseButton"),
    methodSelect: makeNodeComponent("methodSelect"),
    body2: makeNodeComponent("body2"),
    heading2: makeNodeComponent("heading2"),
    initialDeliveryMethodWrapper: makeNodeComponent(
      "initialDeliveryMethodWrapper"
    ),
    buttonBar2: makeNodeComponent("buttonBar2"),
    footer2: makeNodeComponent("footer2"),
    buttons2: makeNodeComponent("buttons2"),
    selectedMethod: makeNodeComponent("selectedMethod"),
    authCodeProvider: makeNodeComponent("authCodeProvider"),
    passwordProvider: makeNodeComponent("passwordProvider"),
    body: makeNodeComponent("body"),
    heading: makeNodeComponent("heading"),
    deliveryMethodWrapper: makeNodeComponent("deliveryMethodWrapper"),
    buttonBar: makeNodeComponent("buttonBar"),
    inputWrapper: makeNodeComponent("inputWrapper"),
    codeInputWrapper: makeNodeComponent("codeInputWrapper"),
    authCodeInput: makeNodeComponent("authCodeInput"),
    authCodeErrorContainer: makeNodeComponent("authCodeErrorContainer"),
    passwordInputWrapper: makeNodeComponent("passwordInputWrapper"),
    passwordInput: makeNodeComponent("passwordInput"),
    passwordErrorContainer: makeNodeComponent("passwordErrorContainer"),
    footer: makeNodeComponent("footer"),
    buttons: makeNodeComponent("buttons"),
    bottom: makeNodeComponent("bottom"),

    // Metadata about props expected for PlasmicMultiFactorAuthModal
    internalVariantProps: PlasmicMultiFactorAuthModal__VariantProps,
    internalArgProps: PlasmicMultiFactorAuthModal__ArgProps
  }
);

export default PlasmicMultiFactorAuthModal;
/* prettier-ignore-end */
